import type { GraphQLTaggedNode } from 'react-relay';
import { graphql } from 'react-relay';
export const MacrosByIdsQuery: GraphQLTaggedNode = graphql`
	query MacrosByIdsQuery($cloudId: ID!, $contentId: ID!, $macroIds: [ID!]!) {
		confluence_macrosByIds(cloudId: $cloudId, contentId: $contentId, macroIds: $macroIds) {
			macroId
			renderedMacro {
				value
				webResource {
					keys
					contexts
					tags {
						js
						css
					}
				}
			}
		}
	}
`;
